import { z } from 'zod';
import { GmailAttachmentMetadataSchema } from './gmailDraft';
import { CHAT_ATTACHMENT_LIMITS } from '../casediscovery/attachmentLimits.js';

/** Hector file budget, the document upload limit itself; not a Google quota. */
export const GMAIL_MAX_FILE_BYTES = CHAT_ATTACHMENT_LIMITS.maxFileSizeBytes;
/** Hector interactive reading budget, shared with the mail host contract. */
export const GMAIL_MESSAGE_MAX_CHARS = 60_000;

export const GmailMessageDetailQuerySchema = z.object({
  includeBody: z.enum(['true', 'false']).default('true').transform((value) => value === 'true'),
  maxChars: z.coerce.number().int().min(1).max(GMAIL_MESSAGE_MAX_CHARS).default(GMAIL_MESSAGE_MAX_CHARS),
}).strict();

const EmailAddressSchema = z.object({ displayName: z.string(), emailAddress: z.string().min(1) }).strict();

/** Provider identity and explicit address metadata for the shared mail host. */
export const GmailMessageDetailResponseSchema = z.object({
  itemId: z.string().min(1), conversationId: z.string().min(1), subject: z.string(),
  from: EmailAddressSchema.nullable(), to: z.array(EmailAddressSchema), dateTimeCreated: z.string().datetime().nullable(),
  itemMode: z.enum(['read', 'compose']), attachments: z.array(GmailAttachmentMetadataSchema),
  body: z.string().optional(), truncated: z.boolean().optional(),
}).strict();
export type GmailMessageDetailResponse = z.infer<typeof GmailMessageDetailResponseSchema>;
